// import stylesheets
import "../stylesheets/application.less";

import $ from "jquery";

window.$ = $;
window.jQuery = $;


import Home from './feature/home';

$(document).ready(() => {
  const page = $("body")
    .children()
    .first()
    .attr("data-page");
  if (!page) {
    return false;
  }
  switch (page) {
    case "home":
      new Home();
      break;
    default:
      throw new Error("No page found.");
  }
});



// WEBPACK FOOTER //
// ./main.js